import { createStore, applyMiddleware } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import thunkMiddleware from 'redux-thunk';
import createSagaMiddleware from 'redux-saga';

import socketMiddleware from './socket';
import RootReducer from './reducers';
import { SERVER_URL } from '../constants/system.keys';
import rootSaga from './saga';
const sagaMiddleware = createSagaMiddleware();

const middlewareSaga = applyMiddleware(sagaMiddleware);

const middleware = applyMiddleware(
  thunkMiddleware,
  socketMiddleware(SERVER_URL)
);

const Store = createStore(
  RootReducer,
  composeWithDevTools(middlewareSaga, middleware)
);

sagaMiddleware.run(rootSaga);

export default Store;
